import React from 'react';
import { Card, CardContent, CardHeader, Typography, Box, Chip } from '@mui/material';

interface InsightCardProps {
  title: string;
  description: string;
  impact: 'High' | 'Medium' | 'Low';
  category: string;
}

const InsightCard: React.FC<InsightCardProps> = ({ title, description, impact, category }) => {
  const getImpactColor = () => {
    switch (impact) {
      case 'High':
        return 'error';
      case 'Medium':
        return 'warning';
      case 'Low':
        return 'info';
      default:
        return 'default';
    }
  };

  return (
    <Card sx={{ height: '100%' }}>
      <CardHeader 
        title={title}
        action={
          <Box sx={{ display: 'flex', gap: 1 }}>
            <Chip 
              label={impact} 
              color={getImpactColor()} 
              size="small" 
              sx={{ height: 24 }}
            />
            <Chip 
              label={category} 
              variant="outlined" 
              size="small" 
              sx={{ height: 24 }}
            />
          </Box>
        }
        titleTypographyProps={{ variant: 'h6' }}
      />
      <CardContent>
        <Typography variant="body1">
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default InsightCard;
